// Defines the canonical menu order for sidebar navigation
// Menu items will be displayed in this exact order
export const MENU_ORDER = [
  'Dashboard',
  'Place An Order',
  'Existing Orders',
  'Deleted Orders',
  'Un-Synced CubiCasa Orders',
  'Sales Customer Info',
  'Estimating Customer Info',
  'Pricing Contracts',
  'One off Unit Quotes',
  'Product Catalog',
  'Labor Catalog',
  'Kits',
  'Admin'
];

// Create a map for O(1) lookup during sorting
// This maps menu names to their display order index
export const MENU_ORDER_MAP = MENU_ORDER.reduce((acc, name, index) => {
  acc[name] = index;
  return acc;
}, {});

// Canonical list of MAIN MENU urls that are governed by role permissions.
// These are the exact route paths the sidebar navigates to (menuUrl === route path).
// The permission guard only restricts direct-URL access to these paths; any other
// route (detail pages, admin value-lists, sub-pages, etc.) is left untouched.
export const MAIN_MENU_URLS = [
  '/dashboard',
  '/place-order',
  '/existing-orders',
  '/deleted-orders',
  '/unsynced-cubicasa-orders',
  '/sale-customer-info',
  '/estimating-customer-info',
  '/PricingContracts',
  '/unit-quotes',
  '/ProductCatalog',
  '/admin/labor/items',
  '/kits',
  '/admin',
  '/lost-customer-parameters'
];

export const ADMIN_MENU_URLS = [
  '/dashboard',
  '/admin/product-catalog/store-list',
  '/admin/labor/catgeory',
  '/admin/labor/items',
  '/admin/sales-person/category',
  '/admin',
  '/role',
  '/product-type',
  '/employee',
  '/customer-approval',
  '/customer-priority',
];
